import React, {memo, useEffect, useRef} from 'react';
import Typography from "../../../../components/Typography";
import Button from "../../../../components/Button";
import PropTypes from "prop-types";
import PasswordForm from "./PasswordForm";
import lottie from 'lottie-web'
import animation from '../../../../utils/lottie_jsons/success.json'

const SuccessContent = ({
                            close,
                            title = "Your new password has <nobr>been set!</nobr>",
                            body = 'You can now Sign In using your email id and the newly <nobr>set password.</nobr>',
                            buttonText = "Sign In",
                            hideOkayButton = false
                        }) => {
    const cracker = useRef(null)
    useEffect(() => {
        lottie.loadAnimation({
            container: cracker?.current,
            loop: true,
            autoplay: true,
            animationData: animation
        })
    }, [])
    return (
        <div>
            <div ref={cracker} className={"h-[130px]"}></div>
            <Typography variant={"h5"} className={"text-body pb-2.5"}><span
                dangerouslySetInnerHTML={{__html: title}}></span></Typography>
            <Typography variant={"body1"} className={"px-4"}><span
                dangerouslySetInnerHTML={{__html: body}}></span></Typography>
            {!hideOkayButton && <Button onClick={close} className={"mt-5"}>{buttonText}</Button>}
        </div>
    );
};


export default memo(SuccessContent);

PasswordForm.propTypes = {
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    close: PropTypes.func,
};
